import * as types from '../../action-types';
import { generatePaymentHistory as initialState } from "../../initialState";

const generatePaymentHistory = (state=initialState, action) => {
  switch (action.type) {
    case types.GENERATE_PAYMENT_HISTORY_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GENERATE_PAYMENT_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GENERATE_PAYMENT_HISTORY_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GENERATE_PAYMENT_HISTORY_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default generatePaymentHistory;
